import parseSearchParams from '@progyny/utils/parseSearchParams'

import i18n from '@root/i18n'

const pickRandomElement = (choices: ArrayLike<Number>) => {
  const min = 0
  const max = choices.length
  return Math.floor(Math.random() * (max - min) + min)
}

// Checking for generic language so we are safe with 'en' but also 'en_US', 'en_UK etc.
const isNotLang = (langCode?: string) => {
  if (!langCode) return null
  return !new RegExp(`(${langCode})`).test(i18n.language)
}

export {parseSearchParams, pickRandomElement, isNotLang}
